import { FC } from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { Card } from '../components/Card';
import { Text } from '../components/Text';
import { HelperBeeButton } from './HelperBeeButton';
import { BeeChatViewModel } from './BeeChatViewModel';
import { useIfLoggedIn } from '../utils/useIfLoggedIn';
import { HistoryViewModel } from '../support/HistoryViewModel';
import { useCanChatWithBea } from './useCanChatWithBea';

export const HelperBeeCard: FC = () => {
    const chatVM = useInstance(BeeChatViewModel);
    const history = useInstance(HistoryViewModel);
    const ifLoggedIn = useIfLoggedIn();
    const canChat = useCanChatWithBea();

    if (!canChat) {
        return null;
    }

    const openChat = () => {
        ifLoggedIn({
            delegate: async () => chatVM.open({ trackingFrom: 'Caregiver Tools' }),
            redirect: `${history.getCurrentLocation().pathname}?openChat=true`,
            message: 'Please sign in or create an account to chat with Bea.',
            trackingFrom: 'BeeLine Chat Button'
        });
    };

    return (
        <div style={{marginBottom: 20}}>
        <Card padded onClick={openChat}>
            <div style={{display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12}}>
                <img src="/assets/images/help/helper-bea.png" alt="Bea" style={{width: 32, height: 32, borderRadius: '50%', objectFit: 'cover'}} />
                <Text><b>Innerhive’s BeeLine</b></Text>
            </div>

            <p>
                <Text type="detail">Bea, your AI care consultant, learns from everything you add. Ask her anything.</Text>
            </p>

            {/* Decorative CTA: the whole card is the tap target, so the pill must not double-handle
                the click (pointer-events off lets the card's onClick own it). */}
            <div style={{margin: '20px auto', maxWidth: 300, textAlign: 'center', display: 'flex', justifyContent: 'center', pointerEvents: 'none'}}>
                <HelperBeeButton coloredBorder trackingFrom="Caregiver Tools" />
            </div>
        </Card>
        </div>
    );
};
